/**
 /**
 * created by tianruojun
 * 媒体code与网站稿件查询接口之间的关系
 */
export const showStoryUrlConfig = {
    "webNews": {
        idKey: "storyId",
        url: "/cm-sites-pms/story/renderWebNewsByStory"
    },
    "default": {
        idKey: "webNewsId",
        url: "/cm-sites-pms/website/news/getById"
    },
};
